module.exports = __webpack_public_path__ + "static/media/living room-06.4002389c.jpg";